<template>
  <v-container fluid>
    <v-data-iterator
      :items="items"
      hide-default-footer
      no-data-text=""
      class="text--black"
    >
      <template v-slot:header>
        <span class="authority-guide-title">権限の凡例</span>
      </template>
      <template v-slot:default="props">
        <v-row dense>
          <v-col
            v-for="(guides, itemIndex) in props.items"
            :key="itemIndex"
            class="authority-guide"
          >
            <div
              v-for="(guide, guideIndex) in guides"
              :key="guideIndex"
              :class="{ 'authority-guide-left': itemIndex === 0 }"
            >
              <div class="authority-guide-wrapper">
                <div class="mark">
                  <span v-if="guide.no !== 999">操作権</span>{{ guide.mark }}
                </div>
                <div class="separator">
                  <span v-if="guide.no !== 999">：</span>
                </div>
                <div class="guide">{{ guide.guide }}</div>
              </div>
            </div>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container>
</template>
<script>
import { operationLevelList } from "@/js/constants/screen-operation";
export default {
  name: "AuthorityGuide",
  data: () => ({
    items: [],
    levels: operationLevelList
  }),

  mounted() {
    this.$emit("operationLevels", this.levels);
    // 凡例の右側に一行空要素を挿入
    const emptyItem = {
      no: 999,
      operation_level: "　",
      mark: "　",
      guide: "　"
    };
    const leftKeys = [1, 3, 5, 7, 9, 10, 12];
    const leftItems = [];
    const rightItems = [];
    this.levels.forEach(level => {
      if (leftKeys.includes(level.no)) {
        leftItems.push(level);
      } else {
        rightItems.push(level);
        if (level.no === 8) {
          rightItems.push(emptyItem);
        }
      }
    });
    this.items = [leftItems, rightItems];
  }
};
</script>
